import React, { useCallback, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import moment from "moment";
import Box from '@material-ui/core/Box';
import { Form } from "reactstrap";
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import HomeIcon from '@material-ui/icons/Home';
import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import 'tui-pagination/dist/tui-pagination.css';
import stylesCoup from '../../Shared/Css/Purchases/Purchas.module.css';


function MaterialListSerche() {
  //사번복고화시작
  const [pwloading, setPwLoading] = useState(0); //실행시 한번만 권한가지기
  const [urlpw, setUrlpw] = useState(0); //실행시 매번 권한가져오기
  //사번복고화종료
  const gridRef = useRef();
  const [materialList, setMaterialList] = useState([]);
  const [purSelectData, setPurSelectData] = useState([]);
  const [supplier, setSupplier] = useState(null); //업체명/코드
  const [materialCode, setMaterialCode] = useState(''); //자재규격
  const [materialGubun, setMaterialGubun] = useState(''); //자재구분
  const [materialYesNo, setMaterialYesNo] = useState('Yes'); //업체자재사용유무
  const [materialNameChange, setMaterialNameChange] = useState('');


  //------------------------------------------------------세션복고화시작
  const pwBog = () => {
    const pwNo = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    //console.log(pwNo);
    pwNo > 0 ? setPwLoading(pwNo) : setPwLoading();
  }

  const pwLogin = () => {
    const pwNoPlus = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    setUrlpw(pwNoPlus)
  }

  useEffect(() => {
    pwBog()
    pwLogin()
    if (pwloading !== urlpw) {
      // window.location.href = '/AcountLogin/Login';
      window.location.assign('/AcountLogin/Login');
    }
    else {
    }
    // refreshPurchaseMaterialList()
  }, [pwloading, urlpw])

  // console.log(`초기값: ${pwloading}`)
  // console.log(`변경값:${urlpw}`)
  //-------------------------------------------------------사번복고화 종료;

  //select 리스트 가져오기
  useEffect(() => {
    axios.get('/api/PurchaseList/')
      .then((res) => {
        setPurSelectData(res.data);
      })
  }, [])


  const haneleSuppilerOnClick = ((e) => {
    //setMaterialNameChange('')
  })

  const haneleMaterialCodeOnChange = ((e) => {
    // e.preventDefault()
    setMaterialCode(e.target.value)
  })
  const haneleMaterialCodeOnClick = ((e) => {
    //setMaterialNameChange('')
  })

  const haneleMaterialGubunOnChange = ((e) => {
    e.preventDefault()
    setMaterialGubun(e.target.value)
  })
  const haneleMaterialGubunOnClick = ((e) => {
    //setMaterialNameChange('')
  })


  //검색클릭 값변경
  const handleInputMaterialNameChange = (e) => {
    e.preventDefault();
    setMaterialNameChange(e.target.value);
  };

  //검색클릭
  const handleInputMaterialNameEnter = (e) => {
    e.preventDefault();
    if (materialNameChange !== '' && e.key === 'Enter') {
      refreshMaterialList(); // null이 아니면 실행됨
    }
    else {
      setMaterialList([]);
    }
  };

  //조회버튼
  const handleFormSerche = (e) => {
    e.preventDefault();
    const evValue = new FormData(e.currentTarget);
    const DataSerche = {
      // s_Id: 30,
      r_자재업체코드: supplier.value ? supplier.value : null,   //업체코드
      r_자재규격: evValue.get("materialCode") ? evValue.get("materialCode") : null,
      r_자재구분: evValue.get("materialGubun") ? evValue.get("materialGubun") : null,
      r_자재사용유무: materialYesNo ? materialYesNo : null,

    }
    // const urlButtonSerche = `/api/PurchaseList/${DataSerche.s_업체코드}/${DataSerche.s_업체사업자번호}/${DataSerche.s_업체주소}`
    const urlButtonSerche = '/api/MaterialsList/Btnserche01/Btnserche02/'
    axios.get(urlButtonSerche, { params: { 
      materialUpcheCode: DataSerche.r_자재업체코드,
      materialCode: DataSerche.r_자재규격,
      materialYesNo: DataSerche.r_자재사용유무 }})
      .then((res) => {
        setMaterialList(res.data);
      })
  };

  const headers = useCallback(() => {
    return {
      'Content-type': `text/plain`,
    };
  }, []);

  const meterialAPI = useCallback(() => {
    const url = '/api/MaterialsList/';
    // const urlFileDown = '/api/VideosMyFileDown/';
    return {
      fetchAll: () => axios.get(url, { params: { materialName: materialNameChange } }),
      create: (newRecord) =>
        axios.post(url, newRecord, { headers }).then((res) => {
          alert('정상적으로 저장되었습니다.');
          // console.log(res.data)
        }).catch(error => {
          alert("[규격[과 [업체명]이 동일할수가 없습니다[중복확인].")
          console.log(error);
        }),
      
      // download: (id) => axios.get(urlFileDown + id, { headers }),
    };
  }, [headers, materialNameChange]);

  const refreshMaterialList = useCallback(async () => {
    await meterialAPI()
      .fetchAll()
      .then((res) => {
        setMaterialList(res.data);
      })
      .catch((err) => console.log(err));
  }, [meterialAPI]);


  //new Grid option 설정부분
  const columns = (
    [
      { name: "No", header: "No", align: "center", width: 'auto' },
      {
        name: "edit", header: "수정", align: "center", width: 60,
        formatter: () => {
          return '<i class="fas fa-edit" style="font-size:16px;color:forestgreen;"></i>';
        }
      },
      // { name: "Id", header: "Id", align: "left", width: 50 }, //숨김처리
      { name: "r_자재코드", header: "코드", align: "center", width: 80 },
      { name: "r_자재품번", header: "품번", align: "left", width: 80 },
      { name: "r_자재규격", header: "규격", align: "left", width: 230 },
      { name: "r_자재계정항목코드", header: "코드", align: "center", width: 100 },
      { name: "r_자재계정항목", header: "항목", align: "center", width: 100 },
      { name: "r_자재계정과목코드", header: "코드", align: "center", width: 90 },
      { name: "r_자재계정과목", header: "과목", align: "left", width: 110 },
      {
        name: "r_자재단위량", header: "단위량", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      { name: "r_자재단위", header: "단위", align: "center", width: 90 },
      {
        name: "r_자재단가", header: "단가", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      { name: "r_자재업체코드", header: "업체코드", align: "center", width: 100 },
      { name: "r_자재업체명", header: "업체명", align: "left", width: 200 },
      { name: "r_자재수불", header: "자재수불", align: "center", width: 80 },
      { name: "r_자재구분", header: "자재구분", align: "center", width: 80 },
      {
        name: "r_등록일자", header: "등록일자", align: "center", width: 110,
        formatter: function (ev) {
          return `${moment(ev.value, "YYYY-MM-DD a hh:mm").format('YYYY-MM-DD HHmm')}`
        }
      },
      { name: "r_등록자", header: "등록자", align: "center", width: 80 },
      {
        name: "delete", header: "삭제", align: "center", width: 50,
        formatter: () => {
          return '<i class="fas fa-trash-alt" style="font-size:16px;color:red;"></i>';
        }
      },
    ]
  );

  //번호, 체크박스 설정부분
  const rowHeaders = [
    // { type: 'rowNum' },
    //{type: 'checkbox'},
  ];

  const rows = materialList.map((row, index) => ({
    //id: row.id,
    No: index + 1,
    edit: '수정',
    // print: '인쇄',
    Id: row.id,
    r_자재코드: row.r_자재코드,
    r_자재품번: row.r_자재품번,
    r_자재규격: row.r_자재규격,
    r_자재계정항목코드: row.r_자재계정항목코드,
    r_자재계정항목: row.r_자재계정항목,
    r_자재계정과목코드: row.r_자재계정과목코드,
    r_자재계정과목: row.r_자재계정과목,
    r_자재단위량: Number(row.r_자재단위량),
    r_자재단위: row.r_자재단위,
    r_자재단가: Number(row.r_자재단가),
    r_자재업체코드: row.r_자재업체코드,
    r_자재업체명: row.r_자재업체명,
    r_자재수불: row.r_자재수불,
    r_자재구분: row.r_자재구분,
    r_등록일자: row.r_등록일자,
    r_등록자: row.r_등록자,
    delete: '삭제'
  }));

  //혜더 복합칼럼설정
  const header = {
    height: 60,
    complexColumns: [
      {
        header: '자재',
        name: '자재',
        childNames: ['r_자재코드', 'r_자재품번', 'r_자재규격']
      },
      {
        header: '계정항목',
        name: '계정항목;',
        childNames: ['r_자재계정항목코드', 'r_자재계정항목']
      },
      {
        header: '계정과목',
        name: '계정과목',
        childNames: ['r_자재계정과목코드', 'r_자재계정과목']
      },
      {
        header: '자재',
        name: '자재',
        childNames: ['r_자재단위량', 'r_자재단위', 'r_자재단가']
      },
      {
        header: '업체',
        name: '업체',
        childNames: ['r_자재업체코드', 'r_자재업체명']
      },
    ]
  }

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      border: 'red',
    },
    outline: {
      // border: 'blue',
      border: '#59b9ea',
      showVerticalBorder: false, //수직선표시여부
    },
    cell: {
      normal: {
        background: 'pink',
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },

      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      rowHeader: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      selectedRowHead: {
        background: '#e5f6ff',
        showVerticalBorder: true
      },
      summary: {
        background: 'pink',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },

    area: {
      header: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      body: {
        border: 'red',
        background: 'white',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      summary: {
        border: '#59b9ea',
        background: 'pink',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        background: 'silver'
      }
    },
  });

  //selectPicker 데이타뿌리기
  const selectData = purSelectData.map(
    item => ({ label: item.s_업체상호, value: item.s_업체코드 })
  );


  return (
    <>
      <div style={{ margin: '10px', textAlign: 'center' }}>
        <h3 style={{ color: "blue" }}>구매자재조회</h3>
      </div>
      <div className={stylesCoup.purchaseBox} >
        <div className={stylesCoup.purchasefind01}>
          <Form onSubmit={handleFormSerche}>
            <div className="input-group mb-12" >
              <Autocomplete
                options={selectData}
                getOptionLabel={(option) => option.label || ''}
                size="small"
                style={{ width: 200, marginRight: 3 }}
                value={supplier ? supplier : setSupplier({ label: '', value: '' })}
                onChange={(event, newValue) => {
                  setSupplier(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="업체" variant="outlined" onClick={haneleSuppilerOnClick} />}
              />
              <TextField
                style={{ width: 150, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="자재규격"
                name="materialCode"
                value={materialCode}
                autoComplete={materialCode}
                onChange={haneleMaterialCodeOnChange}
                onClick={haneleMaterialCodeOnClick}
              />
              <TextField
                style={{ width: 150, marginRight: "2px", float: "center" }}
                variant="outlined"
                size="small"
                label="자재구분"
                name="materialGubun"
                value={materialGubun}
                autoComplete={materialGubun}
                onChange={haneleMaterialGubunOnChange}
                onClick={haneleMaterialGubunOnClick}
              />
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: '#0277bd',
                  color: 'white',
                  height: 36,
                  width: 110,
                  marginRight: 10,
                  float: "center",
                }}
              >
                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '16px' }}></i>
                조회
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<HomeIcon />}
                style={{
                  background: '#004d40',
                  color: 'white',
                  height: 36,
                  width: 110,
                  float: "center",
                }}
                onClick={() => {
                  window.location.href = "/home/index";
                }}
              >
                홈이동
              </Button>
            </div>
          </Form>
        </div>
      </div>
      {/* 검색조회 */}
      <div className={stylesCoup.purchasefind02} >
        <input className={`${stylesCoup.purchaseInput} ${stylesCoup.purchaseBox}`}
          placeholder="검색[Enter]"
          name="materialNameChange"
          value={materialNameChange}
          onChange={handleInputMaterialNameChange}
          onKeyUp={handleInputMaterialNameEnter}
          // onClick={() => {
          //   setMaterialNameChange('');
          //   setSupplier('')
          //   setMaterialCode('')
          //   setMaterialGubun('')
          // }}
        />
      </div>

      <Container maxWidth="xl">
        <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
          <Grid
            columns={columns}
            data={rows}
            header={header}
            scrollY={false}
            rowHeight={"auto"}
            minRowHeight={29}
            //bodyHeight={650}
            bodyHeight={"auto"}
            heightResizable={true}
            virtualScrolling={true}
            rowHeaders={rowHeaders}
            usageStatistics={false}
            pageOptions={{ useClient: true, perPage: 20 }}
            columnOptions={{
              minWidth: 50,
              resizable: true,
            }}
            ref={gridRef}
          />
        </Box>
      </Container>
    </>
  )
}

export default MaterialListSerche